export default __webpack_public_path__ + "static/9-reports2-1e22c548f7004786b7ffeda0271a1f4f.jpg";